import { BLOCKMETA_CONFIRMED_SUBJECT } from '@morfi/nats-client';

export { BLOCKMETA_CONFIRMED_SUBJECT };

export const BLOCKMETA_STREAM_MAX_AGE_MS = 5_000;

export function isBlockmetaCoreSubject(subject: string): boolean {
  return subject === BLOCKMETA_CONFIRMED_SUBJECT;
}
